import {FormField} from '@src/Api/Umbraco/interface/UmbracoTypes';

export const CONSENT_FIELD_ALIASES = {
  terms: 'acceptTnC',
  traceMarketing: 'traceMarketing',
  partnerMarketing: 'partnerMarketing',
} as const;

export const LEGACY_CONSENT_FIELD_ALIASES = {
  terms: 'termsConsent',
  marketing: 'marketingConsent',
  notifications: 'allowNotifications',
} as const;

export const CONSENT_FIELD_DEFAULTS = {
  [CONSENT_FIELD_ALIASES.terms]: false,
  [CONSENT_FIELD_ALIASES.traceMarketing]: false,
  [CONSENT_FIELD_ALIASES.partnerMarketing]: false,
} as const;

export const CONSENT_FIELD_COPY = {
  [CONSENT_FIELD_ALIASES.terms]: {
    caption: 'Accept Terms & Conditions',
    acceptCopy: 'Accept Terms & Conditions',
  },
  [CONSENT_FIELD_ALIASES.traceMarketing]: {
    caption:
      'Stay up to date with TRACE (news, offers, competitions & early access)',
    acceptCopy:
      'Stay up to date with TRACE (news, offers, competitions & early access)',
  },
  [CONSENT_FIELD_ALIASES.partnerMarketing]: {
    caption:
      'Stay up to date with TRACE partners (special offers, contests & exclusive drops)',
    acceptCopy:
      'Stay up to date with TRACE partners (special offers, contests & exclusive drops)',
  },
} as const;

// These defaults are only used when Umbraco does not provide consent fields.
export const DEFAULT_CONSENT_FIELDS: FormField[] = [
  {
    alias: CONSENT_FIELD_ALIASES.terms,
    caption: CONSENT_FIELD_COPY.acceptTnC.caption,
    required: true,
    requiredErrorMessage:
      'You must accept the Terms and Conditions to continue',
    type: 'dataConsent',
    settings: {
      acceptCopy: CONSENT_FIELD_COPY.acceptTnC.acceptCopy,
    },
  },
  {
    alias: CONSENT_FIELD_ALIASES.traceMarketing,
    caption: CONSENT_FIELD_COPY.traceMarketing.caption,
    required: false,
    type: 'checkbox',
    settings: {
      acceptCopy: CONSENT_FIELD_COPY.traceMarketing.acceptCopy,
    },
  },
  {
    alias: CONSENT_FIELD_ALIASES.partnerMarketing,
    caption: CONSENT_FIELD_COPY.partnerMarketing.caption,
    required: false,
    type: 'checkbox',
    settings: {
      acceptCopy: CONSENT_FIELD_COPY.partnerMarketing.acceptCopy,
    },
  },
];
